export enum KabulRet {
    kabul = "kabul",
    ret = "ret",
}

export enum KabulRetLabel {
    kabul = "Kabul Edildi",
    ret = "Reddedildi",
}
